<template lang="pug">
    section
        div.tab-content.scrollbar.is-scrollable
            //- VOLUMES
            div.detail-section
                div.sub-header
                    div.sub-header-title Volumes
                spinner.l-flex-row--center.l-align-center(v-if="volumeLoading", width="160", height="160")
                Volumes(v-else parent="monitoring", :volumes="audienceInfo.volumes")
            //- VOLUMES GRAPH
            div.detail-section
                div.sub-header
                    div.sub-header-title Volumes 30 days
                spinner.l-flex-row--center.l-align-center(v-if="volumesChartLoading", width="160", height="160")
                AudienceVolumeChart(
                    v-else
                    :audienceVolumeData="audienceChartData"
                    :audienceId="audienceInfo.id")
</template>

<script>
// Avoid repeating namespace for each store action/mutation/getter/state
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
dayjs.extend(isSameOrBefore)

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { isEmpty, isEqual, pick, get, find, isNil } from 'lodash'

import AudienceVolumeChart from '@/components/monitoring/AudienceVolumeChart'
import Volumes from '@/components/common/Volumes'

export default {
    name: 'MonitoringMetrics',
    props: {
        audienceInfo: { type: Object, required: true }
    },
    components: {
        AudienceVolumeChart,
        Volumes
    },
    watch: {
        selectedAudienceId: {
            handler: function(newValue, oldValue) {
                if (!isNil(newValue) && !isEqual(newValue, oldValue)) {
                    //checks for chart data volumes retrieval
                    if (this.activeTab === 'metrics' && isEmpty(pick(this.audienceDetails, newValue))) {
                        //checks for chart data volumes retrieval
                        this.retrieveAudienceVolumeFromAudience({ audienceId: newValue })
                    }
                }
            }
        }
    },

    computed: {
        // Call to state
        ...mapState('ui/monitoring', {
            activeTab: state => state.activeTab,
            selectedAudienceHaveDeletedCriteria: state => state.selectedAudienceHaveDeletedCriteria,
            filteredData: state => state.filteredData,
            selectedAudienceId: state => state.selectedRowId,
            volumesChartLoading: state => state.isLoading.volumesChart
        }),
        ...mapState('data/audience', {
            audienceDetails: state => state.audienceDetails
        }),
        ...mapGetters('account', ['getIsMonitoringActionAllowed']),

        volumeLoading() {
            if (!this.audienceInfo.volumes) {
                if (!this.volumesChartLoading) {
                    return false
                }
                return true
            }

            return false
        },

        audienceChartData() {
            if (!this.volumesChartLoading) {
                const currentChartData = pick(this.audienceDetails, this.selectedAudienceId)
                const arrayChartData = get(currentChartData, `${this.selectedAudienceId}`, [])

                const currDate = new Date()
                const startDate = dayjs(currDate).subtract(30, 'days')

                const array30Days = this.enumerateDaysBetweenDates(startDate, currDate).map(date => {
                    const _date = find(arrayChartData, data => data[0] == date)
                    if (_date) return _date
                    return [date, 0]
                })
                return array30Days
            }
            return false
        },
        monitoringActionAllowed() {
            return this.getIsMonitoringActionAllowed()
        }
    },

    methods: {
        // Call to actions
        ...mapActions('data/audience', ['retrieveAudienceVolumeFromAudience', 'retrieveVolumeAlert']),

        // Call to mutations
        ...mapMutations('ui/volumeAlert', ['setShowVolumeAlertForm', 'setIsEditVolumeAlert']),
        // Filter Date
        enumerateDaysBetweenDates(startDate, endDate) {
            let now = startDate
            const dates = []

            while (now.isSameOrBefore(endDate)) {
                dates.push(now.format('YYYY-MM-DD'))
                now = dayjs(now).add(1, 'day')
            }

            return dates
        }
    },
}
</script>
